/** For the button that answers a line: returns what to call once the line is closing, which moves the keyboard focus
 * to the next open line in its column, or to the card when there is none. Without it the focus drops to the page when
 * the line goes. */
export const handOffFocus = (button: HTMLElement): (() => void) => {
  const line = button.closest<HTMLElement>('[data-request-line]');
  return () => {
    if (!line) return;
    const focused = document.activeElement;
    if (focused !== document.body && !line.contains(focused)) return;
    const nextLine = [
      ...(line
        .closest('[data-request-column]')
        ?.querySelectorAll<HTMLElement>('[data-request-line]') ?? []),
    ].find(
      (other) =>
        !other.closest('[inert]') &&
        line.compareDocumentPosition(other) & Node.DOCUMENT_POSITION_FOLLOWING
    );
    const target =
      nextLine?.querySelector<HTMLElement>('button:not(:disabled)') ??
      nextLine ??
      line.closest<HTMLElement>('[data-request-card]');
    target?.focus();
  };
};
